import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface';

export default class CreateDepartmentForm {
  public name: string = '';

  public rules: { [key: string]: FormValidationFunction[] } = {
    nameRules: [
      (v: string) => !!v || 'Department have to have a name',
      (v: string) => v.length >= 3 || 'Department name must be at least 3 characters',
    ],
  };
}
